import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { clearTextSelection } from "./clearTextSelection.js";

var Pointer = /*#__PURE__*/_createClass(function Pointer(nativePointer) {
  _classCallCheck(this, Pointer);

  this.id = nativePointer.pointerId || nativePointer.identifier || -1;
  this.pageX = nativePointer.pageX;
  this.pageY = nativePointer.pageY;
  this.clientX = nativePointer.clientX;
  this.clientY = nativePointer.clientY;
  this.nativePointer = nativePointer;
});

function getDistance(a, b) {
  if (!b) {
    return 0;
  }

  return Math.sqrt(Math.pow(b.clientX - a.clientX, 2) + Math.pow(b.clientY - a.clientY, 2));
}

function getMidpoint(a, b) {
  if (!b) {
    return a;
  }

  return {
    clientX: (a.clientX + b.clientX) / 2,
    clientY: (a.clientY + b.clientY) / 2
  };
}

var PointerTracker = /*#__PURE__*/function () {
  function PointerTracker(element) {
    var _this = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$start = _ref.start,
        start = _ref$start === void 0 ? function () {
      return true;
    } : _ref$start,
        _ref$move = _ref.move,
        move = _ref$move === void 0 ? function () {} : _ref$move,
        _ref$end = _ref.end,
        end = _ref$end === void 0 ? function () {} : _ref$end;

    _classCallCheck(this, PointerTracker);

    this.element = element;
    this.startPointers = [];
    this.currentPointers = [];
    this.startCallback = start;
    this.moveCallback = move;
    this.endCallback = end;

    this.onStart = function (event) {
      if (event.button && event.button !== 0) {
        return;
      }

      var pointer = new Pointer(event);

      if (_this.startCallback(pointer, event) === false) {
        return false;
      }

      event.preventDefault();
      clearTextSelection();

      _this.currentPointers.push(pointer);

      _this.startPointers.push(pointer);

      var capturingElement = event.target && "setPointerCapture" in event.target ? event.target : _this.element;
      capturingElement.setPointerCapture(event.pointerId);

      _this.element.addEventListener("pointermove", _this.onMove);

      _this.element.addEventListener("pointerup", _this.onEnd);

      _this.element.addEventListener("pointercancel", _this.onEnd);
    };

    this.onMove = function (event) {
      var previousPointers = _this.currentPointers.slice();

      var trackedChangedPointers = [];

      var _loop = function _loop() {
        var pointer = _arr[_i];

        var index = _this.currentPointers.findIndex(function (p) {
          return p.id === pointer.id;
        });

        if (index < 0) {
          return "continue";
        }

        trackedChangedPointers.push(pointer);
        _this.currentPointers[index] = pointer;
      };

      for (var _i = 0, _arr = [new Pointer(event)]; _i < _arr.length; _i++) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }

      if (trackedChangedPointers.length) {
        _this.moveCallback(previousPointers, _this.currentPointers, event);
      }
    };

    this.onEnd = function (event) {
      var pointer = new Pointer(event);

      var index = _this.currentPointers.findIndex(function (p) {
        return p.id === pointer.id;
      });

      if (index === -1) {
        return false;
      }

      _this.currentPointers.splice(index, 1);

      _this.startPointers.splice(index, 1);

      _this.endCallback(pointer, event);

      if (!_this.currentPointers.length) {
        _this.element.removeEventListener("pointermove", _this.onMove);

        _this.element.removeEventListener("pointerup", _this.onEnd);

        _this.element.removeEventListener("pointercancel", _this.onEnd);
      }
    };

    this.element.addEventListener("pointerdown", this.onStart);
  }

  _createClass(PointerTracker, [{
    key: "stop",
    value: function stop() {
      this.element.removeEventListener("pointerdown", this.onStart);
      this.element.removeEventListener("pointermove", this.onMove);
      this.element.removeEventListener("pointerup", this.onEnd);
      this.element.removeEventListener("pointercancel", this.onEnd);
    }
  }]);

  return PointerTracker;
}();

export { PointerTracker, getDistance, getMidpoint };